import classNames from "classnames"

import { Button, Icon } from "web/components"

import { daysFromToday, isAValue } from "web/services/helpers"
import { formatAsRelativeDate } from "web/services/format"

import { CalendarIcon } from "@heroicons/react/24/outline"

function AddDate({ handleAddDate, setDateText, className, buttonClassName }) {
  return (
    <span className={className}>
      <Button
        className={buttonClassName}
        size="small"
        variant="secondary_default"
        onClick={handleAddDate}
      >
        {setDateText}
      </Button>
    </span>
  )
}

function DisplayDate({
  date,
  handleRemoveDate,
  readOnly,
  displayPrefix = "",
  compact = true,
  colourise = true,
  className,
}) {
  const canRemove = handleRemoveDate && !readOnly

  const daysTillDate = daysFromToday(date)
  const isInPast = daysTillDate < 0
  const isSoon = daysTillDate >= 0 && daysTillDate < 3

  const dueDateText = formatAsRelativeDate({ value: date }, { compact })

  const dateClass = classNames(
    "p-1 items-center rounded-md flex justify-center text-gray-500 font-medium ring-1 ring-inset ring-gray-600/20",
    className,
    {
      "bg-red-50 text-red-700 ring-red-600/10": colourise && isInPast,
      "bg-yellow-50 text-yellow-800 ring-yellow-600/20": colourise && isSoon,
    }
  )

  function _handleRemoveDate(e) {
    e.stopPropagation()
    handleRemoveDate(e)
  }

  return (
    <div className={dateClass}>
      <CalendarIcon className="mr-1.5 h-4 w-4" />
      <span className="whitespace-nowrap">
        {displayPrefix !== "" ? `${displayPrefix} ${dueDateText}` : dueDateText}
      </span>
      {canRemove && (
        <Icon
          name="x-mark"
          width="16px"
          height="16px"
          onClick={_handleRemoveDate}
          className="ml-1.5 cursor-pointer"
        />
      )}
    </div>
  )
}

export default function TaskDate({
  date,
  handleAddDate,
  setDateText,
  readOnly = false,
  ...rest
}) {
  const hasDate = isAValue(date)
  const canAdd = typeof handleAddDate === "function" && !readOnly

  if (hasDate) {
    return <DisplayDate date={date} readOnly={readOnly} {...rest} />
  } else if (canAdd) {
    return (
      <AddDate
        handleAddDate={handleAddDate}
        setDateText={setDateText}
        {...rest}
      />
    )
  } else {
    return null
  }
}
